export default "__VITE_ASSET__CD1KvcD1__"